import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8wdpzbkr8w: FaireBrandEntity = {
  token: "b_8wdpzbkr8w",
  type: "brand",
  name: "YUZUCO",
  avatarUrl:
    "https://cdn.faire.com/fastly/d44c657d66f290f0e0ea29b47521bf50a113ebf7a17b3daeb63a0cb2f690fee0.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/6d9ca6dea5db77c778a3191227110a828aecc8c44decddd9c34bfded48c2ae6f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d44c657d66f290f0e0ea29b47521bf50a113ebf7a17b3daeb63a0cb2f690fee0.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6d9ca6dea5db77c778a3191227110a828aecc8c44decddd9c34bfded48c2ae6f.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 60,
  rating: 5,
  reviewCount: 24,
  isInsider: false,
  description:
    "YUZUCO is your source for premium citrus juice. We import Japanese yuzu / sudachi and bottle our cold-pressed, never heat-treated juice in California. We also work with locally-grown California Yuzu to make limited and seasonal goods.\n\nOur award winning Super Juice blend (Best New Cocktail Ingredient 2024) makes these wonderful citrus flavors easier than ever to enjoy. We painstakingly developed this bright, convenient and versatile blend to reduce the end cost without sacrificing the true essence of the juice. The best part is, top chefs and bartenders have come to prefer our Super Juice for plenty of uses. It's sharp, harmonious taste and wide-ranging applications have them hooked before even thinking about price.",
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:19:25.642Z",
    importedBy: "entity-db-cli",
  },
};
